import { useEffect } from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useCloseOnEscape = /* @__PURE__ */ __name(() => {
  const { closeDrawer, setIsDrawerOpen } = useNavContext();
  useEffect(() => {
    const closeOnEscape = /* @__PURE__ */ __name(({ key }) => {
      if (key === "Escape") {
        setIsDrawerOpen == null ? void 0 : setIsDrawerOpen(false);
        closeDrawer == null ? void 0 : closeDrawer();
      }
    }, "closeOnEscape");
    document == null ? void 0 : document.addEventListener("keyup", closeOnEscape);
    return () => {
      document == null ? void 0 : document.removeEventListener("keyup", closeOnEscape);
    };
  }, [setIsDrawerOpen, closeDrawer]);
}, "useCloseOnEscape");

export { useCloseOnEscape };
//# sourceMappingURL=use-close-on-escape.js.map
